import React from "react";
import "../css/location.css";
import logo1 from "../assets/logo.png"; // 🔁 change path if needed
export default function Location() {

  // Replace with your actual latitude & longitude
  const latitude = 8.38897023139511;
  const longitude = 77.2800980730824;  //, 

  return (
    <div className="location-container">
        <div className="mobile-header">
        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
        </div>
      <h2 className="location-title">📍 நமது அலுவலகம் இருப்பிடம்</h2>

      <div className="map-container">
       <iframe
        title="Google Map"
        src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
        className="map-frame"
        allowFullScreen=""
        loading="lazy"
        />
      </div>

      <p className="location-text">
        📌 Our Office Location
      </p>

    </div>
  );
}